/// <reference types="./input.d.mts" />
import * as $unsafe from "../../../common_common/gleam/unsafe.mjs";
import * as $bool from "../../../gleam_stdlib/gleam/bool.mjs";
import * as $dynamic from "../../../gleam_stdlib/gleam/dynamic.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $a from "../../../lustre/lustre/attribute.mjs";
import * as $el from "../../../lustre/lustre/element.mjs";
import * as $e from "../../../lustre/lustre/event.mjs";
import { blurTarget as blur_target, preventDefault as prevent_default } from "../../ds.ffi.mjs";
import * as $cy from "../../ds/cypress.mjs";
import * as $s from "../../ds/internals/styles/input.mjs";
import { toList, CustomType as $CustomType } from "../../gleam.mjs";

export { blur_target, prevent_default };

class Model extends $CustomType {
  constructor(label, placeholder, type_, disabled, error, value, icon, on_input, on_submit, on_blur, on_keydown, multiline, id, invisible, enter_submit, data_test, min, max) {
    super();
    this.label = label;
    this.placeholder = placeholder;
    this.type_ = type_;
    this.disabled = disabled;
    this.error = error;
    this.value = value;
    this.icon = icon;
    this.on_input = on_input;
    this.on_submit = on_submit;
    this.on_blur = on_blur;
    this.on_keydown = on_keydown;
    this.multiline = multiline;
    this.id = id;
    this.invisible = invisible;
    this.enter_submit = enter_submit;
    this.data_test = data_test;
    this.min = min;
    this.max = max;
  }
}

class Label extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Placeholder extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Type extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Disabled extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Error extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Value extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Icon extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class OnInput extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class OnBlur extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class OnSubmit extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class OnKeydown extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Multiline extends $CustomType {}

class Invisible extends $CustomType {}

class Id extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class EnterSubmit extends $CustomType {}

class DataTest extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Min extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Max extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

function attributes_to_model(attrs) {
  return $list.fold(
    attrs,
    new Model(
      new None(),
      new None(),
      "text",
      new None(),
      new None(),
      "",
      new None(),
      new None(),
      new None(),
      new None(),
      new None(),
      false,
      new None(),
      false,
      false,
      new None(),
      new None(),
      new None(),
    ),
    (all, attr) => {
      if (attr instanceof Label) {
        let content = attr[0];
        let _record = all;
        return new Model(
          new Some(content),
          _record.placeholder,
          _record.type_,
          _record.disabled,
          _record.error,
          _record.value,
          _record.icon,
          _record.on_input,
          _record.on_submit,
          _record.on_blur,
          _record.on_keydown,
          _record.multiline,
          _record.id,
          _record.invisible,
          _record.enter_submit,
          _record.data_test,
          _record.min,
          _record.max,
        );
      } else if (attr instanceof Placeholder) {
        let content = attr[0];
        let _record = all;
        return new Model(
          _record.label,
          new Some(content),
          _record.type_,
          _record.disabled,
          _record.error,
          _record.value,
          _record.icon,
          _record.on_input,
          _record.on_submit,
          _record.on_blur,
          _record.on_keydown,
          _record.multiline,
          _record.id,
          _record.invisible,
          _record.enter_submit,
          _record.data_test,
          _record.min,
          _record.max,
        );
      } else if (attr instanceof Type) {
        let content = attr[0];
        let _record = all;
        return new Model(
          _record.label,
          _record.placeholder,
          content,
          _record.disabled,
          _record.error,
          _record.value,
          _record.icon,
          _record.on_input,
          _record.on_submit,
          _record.on_blur,
          _record.on_keydown,
          _record.multiline,
          _record.id,
          _record.invisible,
          _record.enter_submit,
          _record.data_test,
          _record.min,
          _record.max,
        );
      } else if (attr instanceof Disabled) {
        let content = attr[0];
        let _record = all;
        return new Model(
          _record.label,
          _record.placeholder,
          _record.type_,
          new Some(content),
          _record.error,
          _record.value,
          _record.icon,
          _record.on_input,
          _record.on_submit,
          _record.on_blur,
          _record.on_keydown,
          _record.multiline,
          _record.id,
          _record.invisible,
          _record.enter_submit,
          _record.data_test,
          _record.min,
          _record.max,
        );
      } else if (attr instanceof Error) {
        let content = attr[0];
        let _record = all;
        return new Model(
          _record.label,
          _record.placeholder,
          _record.type_,
          _record.disabled,
          new Some(content),
          _record.value,
          _record.icon,
          _record.on_input,
          _record.on_submit,
          _record.on_blur,
          _record.on_keydown,
          _record.multiline,
          _record.id,
          _record.invisible,
          _record.enter_submit,
          _record.data_test,
          _record.min,
          _record.max,
        );
      } else if (attr instanceof Value) {
        let content = attr[0];
        let _record = all;
        return new Model(
          _record.label,
          _record.placeholder,
          _record.type_,
          _record.disabled,
          _record.error,
          content,
          _record.icon,
          _record.on_input,
          _record.on_submit,
          _record.on_blur,
          _record.on_keydown,
          _record.multiline,
          _record.id,
          _record.invisible,
          _record.enter_submit,
          _record.data_test,
          _record.min,
          _record.max,
        );
      } else if (attr instanceof Icon) {
        let content = attr[0];
        let _record = all;
        return new Model(
          _record.label,
          _record.placeholder,
          _record.type_,
          _record.disabled,
          _record.error,
          _record.value,
          new Some(content),
          _record.on_input,
          _record.on_submit,
          _record.on_blur,
          _record.on_keydown,
          _record.multiline,
          _record.id,
          _record.invisible,
          _record.enter_submit,
          _record.data_test,
          _record.min,
          _record.max,
        );
      } else if (attr instanceof OnInput) {
        let handler = attr[0];
        let _record = all;
        return new Model(
          _record.label,
          _record.placeholder,
          _record.type_,
          _record.disabled,
          _record.error,
          _record.value,
          _record.icon,
          new Some(handler),
          _record.on_submit,
          _record.on_blur,
          _record.on_keydown,
          _record.multiline,
          _record.id,
          _record.invisible,
          _record.enter_submit,
          _record.data_test,
          _record.min,
          _record.max,
        );
      } else if (attr instanceof OnBlur) {
        let handler = attr[0];
        let _record = all;
        return new Model(
          _record.label,
          _record.placeholder,
          _record.type_,
          _record.disabled,
          _record.error,
          _record.value,
          _record.icon,
          _record.on_input,
          _record.on_submit,
          new Some(handler),
          _record.on_keydown,
          _record.multiline,
          _record.id,
          _record.invisible,
          _record.enter_submit,
          _record.data_test,
          _record.min,
          _record.max,
        );
      } else if (attr instanceof OnSubmit) {
        let handler = attr[0];
        let _record = all;
        return new Model(
          _record.label,
          _record.placeholder,
          _record.type_,
          _record.disabled,
          _record.error,
          _record.value,
          _record.icon,
          _record.on_input,
          new Some(handler),
          _record.on_blur,
          _record.on_keydown,
          _record.multiline,
          _record.id,
          _record.invisible,
          _record.enter_submit,
          _record.data_test,
          _record.min,
          _record.max,
        );
      } else if (attr instanceof OnKeydown) {
        let handler = attr[0];
        let _record = all;
        return new Model(
          _record.label,
          _record.placeholder,
          _record.type_,
          _record.disabled,
          _record.error,
          _record.value,
          _record.icon,
          _record.on_input,
          _record.on_submit,
          _record.on_blur,
          new Some(handler),
          _record.multiline,
          _record.id,
          _record.invisible,
          _record.enter_submit,
          _record.data_test,
          _record.min,
          _record.max,
        );
      } else if (attr instanceof Multiline) {
        let _record = all;
        return new Model(
          _record.label,
          _record.placeholder,
          _record.type_,
          _record.disabled,
          _record.error,
          _record.value,
          _record.icon,
          _record.on_input,
          _record.on_submit,
          _record.on_blur,
          _record.on_keydown,
          true,
          _record.id,
          _record.invisible,
          _record.enter_submit,
          _record.data_test,
          _record.min,
          _record.max,
        );
      } else if (attr instanceof Invisible) {
        let _record = all;
        return new Model(
          _record.label,
          _record.placeholder,
          _record.type_,
          _record.disabled,
          _record.error,
          _record.value,
          _record.icon,
          _record.on_input,
          _record.on_submit,
          _record.on_blur,
          _record.on_keydown,
          _record.multiline,
          _record.id,
          true,
          _record.enter_submit,
          _record.data_test,
          _record.min,
          _record.max,
        );
      } else if (attr instanceof Id) {
        let id$1 = attr[0];
        let _record = all;
        return new Model(
          _record.label,
          _record.placeholder,
          _record.type_,
          _record.disabled,
          _record.error,
          _record.value,
          _record.icon,
          _record.on_input,
          _record.on_submit,
          _record.on_blur,
          _record.on_keydown,
          _record.multiline,
          new Some(id$1),
          _record.invisible,
          _record.enter_submit,
          _record.data_test,
          _record.min,
          _record.max,
        );
      } else if (attr instanceof EnterSubmit) {
        let _record = all;
        return new Model(
          _record.label,
          _record.placeholder,
          _record.type_,
          _record.disabled,
          _record.error,
          _record.value,
          _record.icon,
          _record.on_input,
          _record.on_submit,
          _record.on_blur,
          _record.on_keydown,
          _record.multiline,
          _record.id,
          _record.invisible,
          true,
          _record.data_test,
          _record.min,
          _record.max,
        );
      } else if (attr instanceof DataTest) {
        let content = attr[0];
        let _record = all;
        return new Model(
          _record.label,
          _record.placeholder,
          _record.type_,
          _record.disabled,
          _record.error,
          _record.value,
          _record.icon,
          _record.on_input,
          _record.on_submit,
          _record.on_blur,
          _record.on_keydown,
          _record.multiline,
          _record.id,
          _record.invisible,
          _record.enter_submit,
          new Some(content),
          _record.min,
          _record.max,
        );
      } else if (attr instanceof Min) {
        let content = attr[0];
        let _record = all;
        return new Model(
          _record.label,
          _record.placeholder,
          _record.type_,
          _record.disabled,
          _record.error,
          _record.value,
          _record.icon,
          _record.on_input,
          _record.on_submit,
          _record.on_blur,
          _record.on_keydown,
          _record.multiline,
          _record.id,
          _record.invisible,
          _record.enter_submit,
          _record.data_test,
          new Some(content),
          _record.max,
        );
      } else {
        let content = attr[0];
        let _record = all;
        return new Model(
          _record.label,
          _record.placeholder,
          _record.type_,
          _record.disabled,
          _record.error,
          _record.value,
          _record.icon,
          _record.on_input,
          _record.on_submit,
          _record.on_blur,
          _record.on_keydown,
          _record.multiline,
          _record.id,
          _record.invisible,
          _record.enter_submit,
          _record.data_test,
          _record.min,
          new Some(content),
        );
      }
    },
  );
}

export function label(text) {
  return new Label(text);
}

export function placeholder(text) {
  return new Placeholder(text);
}

export function type_(text) {
  return new Type(text);
}

export function disabled(value) {
  return new Disabled(value);
}

export function error(value) {
  return new Error(value);
}

export function value(value) {
  return new Value(value);
}

export function icon(value) {
  return new Icon(value);
}

export function on_input(handler) {
  return new OnInput(handler);
}

export function on_submit(handler) {
  return new OnSubmit(handler);
}

export function on_blur(handler) {
  return new OnBlur(handler);
}

export function on_keydown(handler) {
  return new OnKeydown(handler);
}

export function multiline() {
  return new Multiline();
}

export function invisible() {
  return new Invisible();
}

export function enter_submit() {
  return new EnterSubmit();
}

export function id(id) {
  return new Id(id);
}

export function data_test(content) {
  return new DataTest(content);
}

export function min(content) {
  return new Min(content);
}

export function max(content) {
  return new Max(content);
}

function select_input_class(model) {
  return $bool.guard(
    model.invisible,
    $s.invisible,
    () => {
      let $ = model.multiline;
      let $1 = model.disabled;
      let $2 = model.error;
      if ($) {
        if ($1 instanceof Some) {
          let $3 = $1[0];
          if ($3) {
            return $s.disabled_multiline;
          } else if ($2 instanceof Some) {
            return $s.error_multiline;
          } else {
            return $s.standard_multiline;
          }
        } else if ($2 instanceof Some) {
          return $s.error_multiline;
        } else {
          return $s.standard_multiline;
        }
      } else if ($1 instanceof Some) {
        let $3 = $1[0];
        if ($3) {
          return $s.disabled;
        } else if ($2 instanceof Some) {
          return $s.error;
        } else {
          return $s.standard;
        }
      } else if ($2 instanceof Some) {
        return $s.error;
      } else {
        return $s.standard;
      }
    },
  );
}

function on_input_submit(model) {
  let capture_events = model.value !== "";
  let $ = model.on_submit;
  if ($ instanceof Some) {
    if (capture_events) {
      let handler = $[0];
      return $e.on_click(handler);
    } else {
      return $a.none();
    }
  } else {
    return $a.none();
  }
}

function input_icon(model) {
  let $ = model.icon;
  if ($ instanceof Some) {
    let icon$1 = $[0];
    let capture_events = model.value !== "";
    return $s.icon_display_wrapper(
      capture_events,
      toList([on_input_submit(model)]),
      toList([$s.icon_display(toList([]), toList([icon$1]))]),
    );
  } else {
    return $el.none();
  }
}

function on_keydown_decoder(model) {
  return $decode.field(
    "metaKey",
    $decode.bool,
    (meta) => {
      return $decode.field(
        "shiftKey",
        $decode.bool,
        (shift) => {
          return $decode.field(
            "key",
            $decode.string,
            (key) => {
              let $ = model.enter_submit;
              if (key === "Enter") {
                if ($) {
                  if (shift) {
                    return $decode.success(false);
                  } else if (meta) {
                    return $decode.success(false);
                  } else {
                    return $decode.success(true);
                  }
                } else if (meta) {
                  return $decode.success(true);
                } else {
                  return $decode.success(false);
                }
              } else {
                return $decode.success(false);
              }
            },
          );
        },
      );
    },
  );
}

function view_error(model) {
  let $ = model.error;
  if ($ instanceof Some) {
    let error$1 = $[0];
    return $s.error_label(toList([]), toList([$el.text(error$1)]));
  } else {
    return $el.none();
  }
}

function unwrap_attribute(attribute, mapper) {
  let _pipe = attribute;
  let _pipe$1 = $option.map(_pipe, mapper);
  return $option.lazy_unwrap(_pipe$1, $a.none);
}

function on_user_keydown(model) {
  return unwrap_attribute(
    model.on_keydown,
    (handler) => {
      return $e.advanced(
        "keydown",
        $decode.then$(
          $decode.dynamic,
          (event) => {
            return $decode.field(
              "key",
              $decode.string,
              (key) => {
                return $decode.success(
                  $e.handler(handler([event, key]), false, false),
                );
              },
            );
          },
        ),
      );
    },
  );
}

function on_enter_keydown(model) {
  let $ = model.on_keydown;
  if ($ instanceof Some) {
    return $a.none();
  } else {
    return unwrap_attribute(
      model.on_submit,
      (msg) => {
        return $e.on(
          "keydown",
          $decode.then$(
            $decode.dynamic,
            (event) => {
              return $decode.then$(
                on_keydown_decoder(model),
                (success) => {
                  let return$ = () => {
                    return $decode.failure($unsafe.coerce(""), "");
                  };
                  return $bool.lazy_guard(
                    !success,
                    return$,
                    () => {
                      blur_target(event);
                      return $decode.success(msg);
                    },
                  );
                },
              );
            },
          ),
        );
      },
    );
  }
}

function view_content(model) {
  let input$1 = select_input_class(model);
  let display_icon = $option.is_some(model.icon);
  return $s.input_wrapper(
    toList([unwrap_attribute(model.data_test, $cy.data)]),
    toList([
      input$1(
        display_icon,
        toList([
          $a.type_(model.type_),
          $a.value(model.value),
          on_user_keydown(model),
          on_enter_keydown(model),
          unwrap_attribute(model.min, $a.min),
          unwrap_attribute(model.max, $a.max),
          unwrap_attribute(model.disabled, $a.disabled),
          unwrap_attribute(model.id, $a.id),
          unwrap_attribute(model.on_input, $e.on_input),
          unwrap_attribute(model.placeholder, $a.placeholder),
          unwrap_attribute(model.on_blur, $e.on_blur),
          (() => {
            let $ = model.multiline;
            if ($) {
              return $a.attribute("rows", "5");
            } else {
              return $a.none();
            }
          })(),
        ]),
      ),
      input_icon(model),
    ]),
  );
}

export function input(attrs) {
  let model = attributes_to_model(attrs);
  let content = view_content(model);
  let error$1 = view_error(model);
  return $s.wrapper(
    toList([$cy.data("input-wrap")]),
    (() => {
      let $ = model.label;
      if ($ instanceof Some) {
        let label$1 = $[0];
        return toList([$el.text(label$1), content, error$1]);
      } else {
        return toList([content, error$1]);
      }
    })(),
  );
}
